import {getTitleMargin, isTitleVisible} from '../../../selectors/single-settings'
import {AppProps} from '../../app/interfaces'
import {renderIfVisible} from '../../hoc/render-if-visible'
import {withMargin} from '../../hoc/with-margin'
import {Title as TitlePresentation} from './title'

const getMargin = ({state}: AppProps) => getTitleMargin(state)

export const Title = renderIfVisible(withMargin(TitlePresentation, getMargin), isTitleVisible)
